var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "-18 0 511 511.99956",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 205.6501449018,
    x2: 306.4750352838,
    y1: 206.8316953046,
    y2: 399.3155678164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2459,
    stopColor: "#05e5b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5301,
    stopColor: "#13ddac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8322,
    stopColor: "#2ad1a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ac9a0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 476.9334614688,
    x2: 58.072707372,
    y1: 490.379625769,
    y2: 71.5188716722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ac9a0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351,
    stopColor: "#38c69d",
    stopOpacity: 0.035294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4167,
    stopColor: "#23aa82",
    stopOpacity: 0.415686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7511,
    stopColor: "#169971",
    stopOpacity: 0.752941
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11936b"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4286,
    stopColor: "#ffbb23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 253.1241103988,
    x2: 289.5724021386,
    xlinkHref: "#c",
    y1: 67.357012629,
    y2: 150.667479799
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(.709873 -.709873 .709873 .709873 1711.310736 -564.47491)",
    gradientUnits: "userSpaceOnUse",
    x1: -1605.0641,
    x2: -1537.3257,
    xlinkHref: "#c",
    y1: -469.2505,
    y2: -282.9698
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 283.9279510858,
    x2: 49.7134504468,
    y1: 291.7293631566,
    y2: 210.8047166196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e58200",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5669,
    stopColor: "#c35e2d",
    stopOpacity: 0.568627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a64153"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientTransform: "matrix(.709873 -.709873 .709873 .709873 1711.310736 -564.47491)",
    gradientUnits: "userSpaceOnUse",
    x1: -1629.1427,
    x2: -1752.5582,
    y1: -550.9688,
    y2: -302.4357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3c3c3"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 179.2119375928,
    x2: 85.2984478276,
    y1: 259.559064932,
    y2: 214.117037563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1b5d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0421,
    stopColor: "#9db1d2",
    stopOpacity: 0.043137
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2868,
    stopColor: "#8b9cb5",
    stopOpacity: 0.286275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7e8ea1",
    stopOpacity: 0.529412
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7693,
    stopColor: "#778594",
    stopOpacity: 0.768627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 142.231990593,
    x2: 142.231990593,
    y1: 286.5738221178,
    y2: 409.6129965548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0633,
    stopColor: "#37355a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4033,
    stopColor: "#232543"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7232,
    stopColor: "#171b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m404.320312 79.667969h-333.546874c-38.8125 0-70.273438 31.464843-70.273438 70.273437v235.578125c0 35.234375 25.9375 64.398438 59.757812 69.472657 5.375.804687 9.40625 5.308593 9.40625 10.738281v26.914062c0 17.210938 20.808594 25.828125 32.976563 13.660157l25.984375-25.984376c15.703125-15.707031 37.003906-24.53125 59.214844-24.53125h216.480468c38.8125 0 70.277344-31.460937 70.277344-70.273437v-235.574219c0-38.808594-31.464844-70.273437-70.277344-70.273437zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m474.59375 215.933594v169.597656c0 38.804688-31.460938 70.265625-70.269531 70.265625h-216.480469c-5.265625 0-10.472656.507813-15.574219 1.464844l-62.277343-62.277344c-3.589844-2.113281-6.015626-6-6.015626-10.46875v-257.828125c0-6.707031 5.4375-12.148438 12.15625-12.148438h52.199219c4.46875 0 8.355469 2.429688 10.464844 6.023438.140625.082031.25.144531.386719.226562h17.261718c4.570313 0 8.554688 2.457032 10.746094 6.117188 1.796875 1.074219 3.300782 2.582031 4.367188 4.375h.042968c9.734376-16.707031 16.789063-33.828125 21.234376-51.609375h87.214843l55.433594 55.445313c11.707031 0 22.9375 4.652343 31.21875 12.929687zm0 0",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m322.882812 57.691406c-2.605468 29.316406-9.722656 57.5625-21.347656 84.628906h-96.753906c23.609375-35.753906 34.65625-73.175781 33.75-114.761718-.273438-13.210938 9.289062-24.589844 22.328125-26.722656.285156-.042969.5625-.085938.847656-.128907 34.113281-5.574219 64.21875 22.542969 61.175781 56.984375zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m377.269531 135.496094-226.824219-.015625v240.238281h184.710938c31.394531 0 58.1875-22.695312 63.355469-53.660156l18.507812-139.628906c4.097657-24.570313-14.84375-46.933594-39.75-46.933594zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m323.097656 375.71875h12.058594c22.101562 0 41.914062-11.257812 53.515625-28.722656l-180.382813-211.511719-57.84375-.003906v240.238281zm0 0",
    fill: "url(#f)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m196.441406 390.410156h-28.695312c-6.925782 0-12.539063-5.613281-12.539063-12.539062v-244.539063c0-6.925781 5.613281-12.539062 12.539063-12.539062h28.695312c6.925782 0 12.539063 5.613281 12.539063 12.539062v244.539063c0 6.925781-5.613281 12.539062-12.539063 12.539062zm0 0",
    fill: "url(#g)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m177.261719 120.792969h-9.515625c-6.925782 0-12.539063 5.613281-12.539063 12.539062v244.539063c0 6.925781 5.613281 12.539062 12.539063 12.539062h28.695312c6.925782 0 12.539063-5.613281 12.539063-12.539062v-225.363282zm0 0",
    fill: "url(#h)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m168.335938 396.664062h-52.207032c-6.707031 0-12.148437-5.441406-12.148437-12.148437v-257.828125c0-6.710938 5.4375-12.148438 12.148437-12.148438h52.207032c6.710937 0 12.148437 5.4375 12.148437 12.148438v257.828125c0 6.707031-5.441406 12.148437-12.148437 12.148437zm0 0",
    fill: "url(#i)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbsUp);
export default __webpack_public_path__ + "static/media/icon-thumbs-up.16dc1660deb6ae734748e58da6628c0a.svg";
export { ForwardRef as ReactComponent };